import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import UserEditor from "./UserEditor";
import PropertiesEditor from "./PropertiesEditor";

export default class Editor extends Component {

    render() {
        return (
            <Switch>
                <Route exact path="/user/edit/profile" component={UserEditor}/>
                <Route exact path="/user/edit/property/:propId" render={ps =>(<PropertiesEditor propId={ps.match.params.propId}/>)}/>
                <Redirect to="/user"/>
            </Switch>
        );
    }

}